/* ============================================================================
   WORKFLOW — dropdown Control Panel tab Flow · Workspace v4 mod New · 3 Nov 2026 ("Cara A")
   ============================================================================
   Senarai = page /workflow SEBENAR (config/workflow_galeri, didengar langsung) — admin ubah nama /
   ayat / susunan di sana, dropdown ikut serta-merta. Workflow muncul HANYA bila ia bersambung ke
   robot (medan `robot`, utils/workflowRobot.js) DAN serasi dengan Formula card yang ditick.
     · tiada card ditick → kelabu "Tick a card first"
     · card bercampur Formula → "N workflows" + amaran (satu Run = satu robot, pagar sedia ada)
     · satu Formula → dipilih sendiri; AI8SAAT boleh tukar ke "card images" (nilai flowWorkflow sedia ada)
   ⛔ Komponen ini TIDAK menambah medan payload baharu. Satu-satunya nilai yang mengubah larian ialah
      `flowWorkflow` ('generate' | 'kad') — laluan sedia ada (App.jsx → WorkspaceView → payload).
      Workflow lain ditentukan Formula card, jadi memilihnya tidak mengubah apa-apa selain paparan.
   ⛔ Blank card: semua workflow bersambung dipapar (utils/workflowBlankCard.js — agent lain menapis).
      Pilihan selain BLANK_SUDAH_JALAN belum mengubah Run → amaran kuning dipapar, bukan senyap.
   ⚠️ Mod New = admin sahaja (useGenerateV2). Hari buka kepada pelanggan: rules config/workflow_galeri
      perlu `allow read` untuk pelanggan + deploy rules — kalau tidak dropdown kosong (ralat dipapar).
   ========================================================================== */

import { useEffect, useMemo, useState } from 'react';
import { useT } from '../i18n';
import PilihWorkflowKaya from './PilihWorkflowKaya';
import { dengarGaleriWorkflow } from '../services/galeriWorkflowService';
import { keputusanDropdown, robotWfIkutId } from '../utils/workflowRobot';
import { BLANK_SUDAH_JALAN } from '../utils/workflowBlankCard';

export default function WorkflowDropdownV4({ ringkasan = [], flowWorkflow = 'generate', onFlowWorkflow, tunjukDraft = false }) {
    const t = useT();
    const [galeri, setGaleri] = useState({ sedia: false, ada: false, senarai: [], rosak: 0, ralat: '' });
    const [robotBlank, setRobotBlank] = useState('');

    useEffect(() => dengarGaleriWorkflow(
        (d) => setGaleri({ sedia: true, ...d, ralat: '' }),
        (e) => {
            console.error('[WorkflowDropdownV4] gagal baca senarai workflow:', e);
            setGaleri((g) => ({ ...g, sedia: true, ralat: e?.message || String(e) }));
        },
    ), []);

    const k = useMemo(
        () => keputusanDropdown({ senarai: galeri.senarai, ringkasan, flowWorkflow, tunjukDraft, robotBlank }),
        [galeri.senarai, ringkasan, flowWorkflow, tunjukDraft, robotBlank],
    );

    const pilih = (w) => {
        const r = robotWfIkutId(w.robot);
        if (!r) return;
        if (k.jenis === 'blank') setRobotBlank(r.id);
        if (r.cara === 'flowWorkflow') onFlowWorkflow?.(r.flowWorkflow);
    };

    /* Isi butang tertutup bila tiada satu workflow terpilih. */
    let ganti = null;
    let nota = null;
    let notaAmaran = false;
    if (galeri.ralat) {
        ganti = <span className="wfp-nota">{t('workspace.wfV4.loadError')}</span>;
        nota = galeri.ralat;
        notaAmaran = true;
    } else if (galeri.sedia && !galeri.ada) {
        ganti = <span className="wfp-nota">{t('workspace.wfV4.empty')}</span>;
        nota = t('workspace.wfV4.emptyNote');
        notaAmaran = true;
    } else if (k.keadaan === 'tiada') {
        ganti = <span className="wfp-nota">{t('workspace.wfV4.tickFirst')}</span>;
        nota = t('workspace.wfV4.tickFirstNote');
    } else if (k.keadaan === 'campur') {
        ganti = (
            <>
                <span className="wfp-nama">{t('workspace.wfV4.mixed', { n: k.ringkasan.length })}</span>
                <span className="wfp-nota">{k.ringkasan.map((x) => `${x.label} (${x.bil})`).join(' · ')}</span>
            </>
        );
        nota = t('workspace.wfV4.mixedNote');
        notaAmaran = true;
    } else if (!k.nilai) {
        ganti = <span className="wfp-nota">{t('workspace.wfV4.noneLinked', { formula: k.ringkasan[0]?.label || '' })}</span>;
        nota = t('workspace.wfV4.noneLinkedNote');
        notaAmaran = true;
    } else if (k.jenis === 'blank') {
        const r = k.pilihan.find((w) => w.id === k.nilai)?.robot;
        if (r && !BLANK_SUDAH_JALAN.includes(r)) { nota = t('workspace.wfV4.blankNote'); notaAmaran = true; }
    }

    const disabled = !!ganti && k.keadaan !== 'satu';

    return (
        <div className="s-sect">
            <p className="s-sect__title">{t('workspace.workflow.title')}</p>
            <PilihWorkflowKaya
                pilihan={k.pilihan}
                nilai={k.nilai}
                onPilih={pilih}
                disabled={disabled || !galeri.sedia}
                ganti={ganti}
                kakiMenu={k.jenis === 'blank' ? null : t('workspace.wfV4.fromFormula')}
            />
            {nota && (
                <p className="s-hint" style={{ margin: 0, color: notaAmaran ? 'var(--s-warn)' : undefined }}>{nota}</p>
            )}
            {galeri.rosak > 0 && (
                <p className="s-hint" style={{ margin: 0, color: 'var(--s-warn)' }}>{t('workspace.wfV4.rosak', { n: galeri.rosak })}</p>
            )}
        </div>
    );
}
